export default __webpack_public_path__ + "static/media/samandehi.69639753.png";